const formContainer = document.querySelector(".esg-test__form");
const form = document.querySelector(".esg-test__form form");
const questions = Array.from(document.querySelectorAll(".question"));
const panelContainer = document.querySelector(".esg-test__panel");
const scoreContainer = document.querySelector(".esg-test__score");
const resultsContainer = document.querySelector(".esg-test__results");
const answerEl = document.querySelector(".esg-test__results .answer");
const tipDescriptionEl = document.querySelector(".esg-test__results .tip--description");
const tipLinkEl = document.querySelector(".esg-test__results .tip--link a");
const yesBtn = document.querySelector(".yes");
const noBtn = document.querySelector(".no");
const nextBtn = document.querySelector(".next");
const backBtn = document.querySelector(".back");

if (formContainer) {
    let currentQuestion = questions[0];

    function setAnswer(answer) {
        currentQuestion.dataset.answer = answer;
        yesBtn.classList.toggle("active", answer === "yes");
        noBtn.classList.toggle("active", answer === "no");
        nextBtn.classList.toggle("disabled", !answer);
    }

    yesBtn.addEventListener("click", () => {
        setAnswer("yes");
        yesBtn.classList.remove("alert");
        noBtn.classList.remove("alert");
        nextBtn.disabled = false;
    });

    noBtn.addEventListener("click", () => {
        setAnswer("no");
        yesBtn.classList.remove("alert");
        noBtn.classList.remove("alert");
        nextBtn.disabled = false;
    });

    nextBtn.addEventListener("click", function () {
        if (!yesBtn.classList.contains("active") && !noBtn.classList.contains("active")) {
            yesBtn.classList.add("alert");
            noBtn.classList.add("alert");
            nextBtn.disabled = true;
            return;
        }

        yesBtn.classList.remove("alert");
        noBtn.classList.remove("alert");

        const currentIndex = questions.indexOf(currentQuestion);
        if (currentIndex === questions.length - 1) {
            formContainer.classList.add("show");
            panelContainer.classList.add("hidden");
            return;
        }

        const currentStep = document.querySelector(`#Step${currentIndex + 1}`);
        currentStep.style.opacity = "";

        currentQuestion.classList.remove("current");
        currentQuestion = questions[currentIndex + 1];
        currentQuestion.classList.add("current");

        const nextStep = document.querySelector(`#Step${currentIndex + 2}`);
        nextStep.style.opacity = 1;

        backBtn.style.display = currentIndex === 0 ? "inline-block" : "";

        setAnswer("");
    });

    backBtn.addEventListener("click", function () {
        const currentIndex = questions.indexOf(currentQuestion);
        if (currentIndex === 0) {
            return;
        }

        const currentStep = document.querySelector(`#Step${currentIndex}`);
        const lastStep = document.querySelector(`#Step${currentIndex + 1}`);

        currentStep.style.opacity = "1";
        lastStep.style.opacity = "";

        currentQuestion.classList.remove("current");
        currentQuestion = questions[currentIndex - 1];
        currentQuestion.classList.add("current");

        backBtn.style.display = currentIndex === 1 ? "none" : "inline-block";
        nextBtn.innerText = "Next";

        setAnswer("");
    });

    function determineLevel(items) {
        let level = "";
        let yesCount = 0;

        for (let i = 0; i < 3; i++) {
            if (items[i].dataset.answer === "no") {
                level = "beginner";
                return level;
            } else if (items[i].dataset.answer === "yes") {
                yesCount++;
            }
        }

        for (let i = 3; i < 6; i++) {
            if (items[i].dataset.answer === "no") {
                level = "novice";
                return level;
            } else if (items[i].dataset.answer === "yes") {
                yesCount++;
            }
        }

        for (let i = 6; i < 9; i++) {
            if (items[i].dataset.answer === "no") {
                level = "expert";
                return level;
            } else if (items[i].dataset.answer === "yes") {
                yesCount++;
            }
        }

        if (yesCount === 9) {
            level = "maestro";
        } else {
            level = "expert";
        }

        return level;
    }

    window.addEventListener("load", () => {
        form.addEventListener("submit", (event) => {
            event.preventDefault();

            const esgData = new FormData(form);
            const answers = questions.map((q) => q.getAttribute("data-answer"));
            esgData.append("answers", JSON.stringify(answers));

            fetch("/wp/wp-admin/admin-ajax.php?action=submit_questionnaire", {
                method: "POST",
                body: esgData,
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then((data) => {
                    console.log(data);
                    if (data.success) {
                        formContainer.classList.remove("show");
                        resultsContainer.classList.add("show");
                        answerEl.innerHTML = data.data.result;
                        tipDescriptionEl.innerHTML = data.data.tip;
                        tipLinkEl.href = data.data.link.url;
                        tipLinkEl.innerHTML = data.data.link.title;
                        document.querySelector("#Step10").style.opacity = 1;
                        scoreContainer.classList.add("show");
                        scoreContainer.classList.add(determineLevel(questions));
                        resultsContainer.classList.add(determineLevel(questions));
                        panelContainer.classList.remove("hidden");
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        });
    });
}
